import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7476f5fe")

_pushScopeId("data-v-7476f5fe")
const _hoisted_1 = { class: "team__label" }
const _hoisted_2 = {
  key: 0,
  class: "team__icon"
}
const _hoisted_3 = {
  key: 0,
  class: "icon-crown"
}
const _hoisted_4 = {
  key: 1,
  class: "icon-star"
}
const _hoisted_5 = {
  key: 1,
  class: "team__name"
}
const _hoisted_6 = {
  key: 2,
  class: "team__name--alt"
}
const _hoisted_7 = {
  key: 3,
  class: "team__icon"
}
const _hoisted_8 = {
  key: 0,
  class: "icon-crown"
}
const _hoisted_9 = {
  key: 1,
  class: "icon-star"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamBadge = _resolveComponent("TeamBadge")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.invert)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.captain)
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : (_ctx.favorite)
              ? (_openBlock(), _createBlock("i", _hoisted_4))
              : (_openBlock(), _createBlock(_component_TeamBadge, {
                  key: 2,
                  team: _ctx.team,
                  link: _ctx.link,
                  class: {'noBadge': !_ctx.badge}
                }, null, 8, ["team", "link", "class"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.teamName && _ctx.team)
      ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.team.name), 1))
      : (_ctx.teamName)
        ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.alt), 1))
        : _createCommentVNode("", true),
    (_ctx.invert)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (_ctx.captain)
            ? (_openBlock(), _createBlock("i", _hoisted_8))
            : (_ctx.favorite)
              ? (_openBlock(), _createBlock("i", _hoisted_9))
              : (_openBlock(), _createBlock(_component_TeamBadge, {
                  key: 2,
                  team: _ctx.team,
                  link: _ctx.link,
                  class: {'noBadge': !_ctx.badge}
                }, null, 8, ["team", "link", "class"]))
        ]))
      : _createCommentVNode("", true)
  ]))
})